import styled, { css } from 'styled-components';
import { colors, fonts } from '../../theme/styled';
import { Link as LinkComponent } from '../link/link.component';
import { getImageSource } from '../../utils/image';
import { getDevicePixelRatio } from '../../theme/media';

export const Container = styled.div`
  position: relative;
  display: inline-flex;
  width: 68px;
  height: 100%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Icon = styled.div`
  display: inline-block;
  width: 44px;
  height: 44px;
  background-image: url(${props => getImageSource(props.image, 44 * getDevicePixelRatio())});
  background-size: cover;
`;

export const Dropdown = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  right: 0;
  top: 100%;
  min-width: 160px;
  background-color: ${colors.grey};
  position: absolute;
 ${props => !props.isVisible && css`display: none`};
  
  &:before {
    content: '';
    width: 0; 
    height: 0; 
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid ${colors.grey};
    position: absolute;
    bottom: 100%;
    right: 30px;
  }
`;

export const Language = styled.li`
  display: flex;
  height: 48px;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  
  &:hover {
    background-color: #313e4a;
  }
`;

export const Label = styled.span`
  display: inline-block;
  margin-left: 4px;
  font-family: ${fonts.smallFont};
  color: ${colors.white};
  font-size: 14px;
  line-height: 100%;
`;

export const Link = styled(LinkComponent)`
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding: 0 8px;
`;

export const ToggleButton = styled.button`
  border: none;
  display: inline-flex;
  background: none;
  align-self: stretch;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
